import { formatDate, mString } from 'lib/helpers/utility';

import Status from 'components/shared/Status/Status';

import PackagePopover from '../components/PackagePopover';

export const getColDefs = () => {
  return [
    { headerName: 'Name', field: 'name' },
    {
      headerName: 'Purchase date',
      field: 'created_at',
      valueGetter: ({ data }) => {
        return formatDate(data.created_at);
      }
    },
    {
      headerName: 'Valid until',
      field: 'validUntil'
    },
    {
      headerName: 'Balance',
      field: 'balance',
      valueGetter: ({ data: pack }) => {
        return mString(pack?.balance);
      }
    },
    {
      headerName: 'Status',
      field: 'status',
      cellRenderer: ({ value }) => {
        return <Status status={value} className="flex justify-center" />;
      }
    },
    {
      field: 'actions',
      headerName: '',
      cellRenderer: PackagePopover,
      maxWidth: 70,
      cellClass: 'no-border',
      resizable: false,
      pinned: 'right'
      // suppressCellClickSelection: true
    }
  ];
};
